@if (hasPanels()) {
  <div class="config-container shadow mt-4">
    <h4
      (click)="toggleCollapse(SubStepEnum.Panels)"
      [ngClass]="{ active: subStep === SubStepEnum.Panels }"
      class="title configurator-subtitle collapse-button">
      <span>{{ 'fence.materials.panels' | translate }}</span>
      <span class="title-count">{{ panels?.length }} {{ 'fence.materials.available-panels' | translate }}</span>
    </h4>

    @if (!configuration.hasValidQuotation && !isPanelsValid) {
      <span class="disabled-product pt-1 ml-4">{{ disableMessage }}</span>
    }

    @if (configuration.hasValidQuotation && !isPanelsValid) {
      <span class="disabled-with-quotation-product pt-1 ml-4">{{ 'fence.materials.valid-quotation-message' | translate }}</span>
    }

    @if (subStep === SubStepEnum.Panels) {
      <div class="collapse-block">
        <div class="decoration-form-row">
          <div class="decoration-form-group">
            <ng-fence-side-panel-count></ng-fence-side-panel-count>
          </div>
        </div>
        <button (click)="deleteAllPanels()" class="decoration-delete">
          {{ 'fence.materials.delete-decorations' | translate }}
        </button>
        <div class="decoration-container">
          @for (panel of panels; track panel.id) {
            <div [ngClass]="{disabled: panel.isDisabled}"
                 class="decoration-card">
              <img [src]="baseImgURL + panel.icon" alt="panel-img" class="decoration-img" />
              <div class="decoration-content">
                @if (currentLang === 'fr') {
                  <p class="decoration-title">{{ panel.nameFr }}</p>
                } @else {
                  <p class="decoration-title">{{ panel.nameEn }}</p>
                }

                <!-- Horizontal -->
                @if (hasHorizontalPanels() && panel.canBeHorizontal) {
                  <div class="decoration-form-row">
                    <div class="decoration-form-group">
                      <input
                        (change)="addPanel('horizontal', panel)"
                        [checked]="isPanelChecked('horizontal', panel)"
                        [id]="'panel' + panel.id + 'horizontal'"
                        type="checkbox" />
                      <label [for]="'panel' + panel.id + 'horizontal'">{{ 'fence.materials.horizontal' | translate }}</label>
                    </div>
                    <div class="decoration-form-group form-row">
                      <div class="form-label">
                        <label [for]="'panel' + panel.id + 'horizontal_qty'">{{
                            'fence.materials.quantity' | translate
                          }}</label>
                      </div>
                      <div class="form-input">
                        <input
                          (change)="changePanelQuantity('horizontal', panel, null, $event)"
                          [disabled]="!isPanelChecked('horizontal', panel)"
                          [id]="'panel' + panel.id + 'horizontal_qty'"
                          [max]="maxHorizontalElement(panel)"
                          [value]="getPanelQuantity('horizontal', panel.id, null)"
                          autocorrect="off"
                          min="0"
                          spellcheck="false"
                          type="number" />
                      </div>
                    </div>
                  </div>
                }

                <!-- Vertical -->
                @if (hasVerticalPanels() && panel.canBeVertical) {
                  <div class="decoration-form-row">
                    <div class="decoration-form-group">
                      <input
                        (change)="addPanel('vertical', panel)"
                        [checked]="isPanelChecked('vertical', panel)"
                        [id]="'panel' + panel.id + 'vertical'"
                        type="checkbox" />
                      <label [for]="'panel' + panel.id + 'vertical'">{{ 'fence.materials.vertical' | translate }}</label>
                    </div>
                    <div class="decoration-form-group form-row">
                      <div class="form-label">
                        <label [for]="'panel' + panel.id + 'vertical_qty'">{{
                            'fence.materials.total-quantity' | translate
                          }}</label>
                      </div>
                      <div class="form-input">
                        <input
                          [disabled]="true"
                          [id]="'panel' + panel.id + 'vertical_qty'"
                          [value]="getPanelQuantity('vertical', panel.id, null)"
                          autocorrect="off"
                          min="0"
                          spellcheck="false"
                          type="number" />
                      </div>
                    </div>
                  </div>
                }

                @if (isPanelChecked('vertical', panel)) {
                  <div class="decoration-form-row justify-content-end">
                    <div class="decoration-form-group">
                      @for (side of configuration.sides; track side.id) {
                        <div class="decoration-form-group form-row mb-2 pr-0">
                          <div class="form-label">
                            <label [for]="'panel' + side.id + '_' + panel.id + 'vertical_qty'">
                              {{ 'fence.materials.side' | translate }} {{ side.id }}</label
                            >
                          </div>
                          <div class="form-input">
                            <input
                              (change)="changePanelQuantity('vertical', panel, side.id, $event)"
                              [disabled]="!isPanelChecked('vertical', panel) || maxVerticalElement(panel, side) <= 0"
                              [id]="'panel' + side.id + '_' + panel.id + 'vertical_qty'"
                              [max]="maxVerticalElement(panel, side)"
                              [value]="getPanelQuantity('vertical', panel.id, side.id)"
                              autocorrect="off"
                              min="0"
                              spellcheck="false"
                              type="number" />
                          </div>
                        </div>
                      }
                    </div>
                  </div>
                }
              </div>
            </div>
          } @empty {
            <ng-casto-loader></ng-casto-loader>
          }

        </div>
      </div>
    }

  </div>
}

